export const groupBy = <T, S extends string>(
  arr: T[],
  cb: (el: T) => S,
): Record<S, T[]> =>
  arr.reduce(
    (acc, x) => {
      (acc[cb(x)] = acc[cb(x)] || []).push(x);
      return acc;
    },
    {} as Record<S, T[]>,
  );
